import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { StaffVacationsService } from "lib-klab-sdks";
import { StaffVacationsPort } from "../../../app/ports/employment/staff-vacations.port";
import {
  VacationBalance,
  VacationCancellation,
  VacationCreateRequest,
  VacationDecision,
  VacationDecisionRequest,
  VacationEntitlementRequest,
  VacationMovement,
  VacationRequest,
  VacationRequestDetail,
  VacationRequestStatus,
  VacationType,
} from "../../../domain/models/employment/vacation.model";
import {
  mapVacationBalance,
  mapVacationCancellation,
  mapVacationCreateRequest,
  mapVacationDecision,
  mapVacationDecisionRequest,
  mapVacationEntitlementRequest,
  mapVacationMovement,
  mapVacationRequest,
  mapVacationRequestDetail,
  mapVacationType,
} from "../../mappers/employment/vacation.mapper";

@Injectable({ providedIn: "root" })
export class StaffVacationsPortAdapter implements StaffVacationsPort {
  constructor(private readonly api: StaffVacationsService) {}

  listTypes(): Observable<VacationType[]> {
    return this.api.listTypes().pipe(map((items) => items.map(mapVacationType)));
  }

  getBalance(employeeId: number): Observable<VacationBalance> {
    return this.api.getBalance(employeeId).pipe(map(mapVacationBalance));
  }

  setEntitlement(
    employeeId: number,
    request: VacationEntitlementRequest,
  ): Observable<VacationBalance> {
    return this.api
      .setEntitlement(employeeId, mapVacationEntitlementRequest(request))
      .pipe(map(mapVacationBalance));
  }

  listMovements(employeeId: number): Observable<VacationMovement[]> {
    return this.api
      .listMovements(employeeId)
      .pipe(map((items) => items.map(mapVacationMovement)));
  }

  listRequests(filters?: {
    employeeId?: number;
    status?: VacationRequestStatus;
  }): Observable<VacationRequest[]> {
    return this.api
      .listRequests(filters)
      .pipe(map((items) => items.map(mapVacationRequest)));
  }

  getRequest(requestId: number): Observable<VacationRequestDetail> {
    return this.api.getRequest(requestId).pipe(map(mapVacationRequestDetail));
  }

  createRequest(request: VacationCreateRequest): Observable<VacationRequest> {
    return this.api
      .createRequest(mapVacationCreateRequest(request))
      .pipe(map(mapVacationRequest));
  }

  decideRequest(
    requestId: number,
    request: VacationDecisionRequest,
  ): Observable<VacationDecision> {
    return this.api
      .decideRequest(requestId, mapVacationDecisionRequest(request))
      .pipe(map(mapVacationDecision));
  }

  cancelRequest(requestId: number): Observable<VacationCancellation> {
    return this.api.cancelRequest(requestId).pipe(map(mapVacationCancellation));
  }
}
